// extracted by mini-css-extract-plugin
module.exports = {"mainBlock__refFunc":"button_mainBlock__refFunc__1tvcF"};